(function () {
  function setAfterWidth(root, clientX) {
    var rect = root.getBoundingClientRect();
    var x = clientX - rect.left;
    if (x < 0) x = 0;
    if (x > rect.width) x = rect.width;
    layoutFromAfterWidth(root, rect.width - x);
  }

  function layoutFromAfterWidth(root, wAfter) {
    var layer = root.querySelector('[data-ba-after-layer]');
    var arrow = root.querySelector('[data-ba-arrow]');
    if (!layer || !arrow) return;
    var rect = root.getBoundingClientRect();
    if (wAfter < 0) wAfter = 0;
    if (wAfter > rect.width) wAfter = rect.width;
    layer.style.width = wAfter + 'px';
    var left = rect.width - 29 - wAfter;
    if (left < 0) left = 0;
    arrow.style.left = left + 'px';
  }

  function layoutInitial(root) {
    var rect = root.getBoundingClientRect();
    layoutFromAfterWidth(root, rect.width / 2);
  }

  function init(root) {
    if (root.getAttribute('data-ba-init') === '1') return;
    root.setAttribute('data-ba-init', '1');

    layoutInitial(root);

    var dragging = false;
    var pid = null;

    function clientXFromEvent(e) {
      if (e.touches && e.touches[0]) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
      return e.clientX;
    }

    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      pid = e.pointerId;
      try {
        root.setPointerCapture(pid);
      } catch (_) {}
      setAfterWidth(root, clientXFromEvent(e));
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      if (e.pointerId != null && pid != null && e.pointerId !== pid) return;
      setAfterWidth(root, clientXFromEvent(e));
    }

    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      try {
        root.releasePointerCapture(pid);
      } catch (_) {}
      pid = null;
    }

    root.addEventListener('pointerdown', onDown);
    root.addEventListener('pointermove', onMove);
    root.addEventListener('pointerup', onUp);
    root.addEventListener('pointercancel', onUp);

    window.addEventListener(
      'resize',
      function () {
        var layer = root.querySelector('[data-ba-after-layer]');
        if (!layer) return;
        var w = parseFloat(layer.style.width);
        if (!(w > 0)) {
          layoutInitial(root);
          return;
        }
        var rect = root.getBoundingClientRect();
        setAfterWidth(root, rect.left + (rect.width - w));
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-ae-clinical-ba]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
